export function initHeaderScroll() {
    const headerWrapper = document.querySelector('.headerMainWrapper');
    if (!headerWrapper) return;

    let lastScrollY = window.scrollY;
    let ticking = false;
    const scrollThreshold = 200; // Header wird erst nach 200px Scroll relevant

    const updateHeader = () => {
        const currentScrollY = window.scrollY;
        const scrollingDown = currentScrollY > lastScrollY;

        // Nur relevant wenn schon etwas gescrollt wurde
        if (currentScrollY > scrollThreshold) {
            if (scrollingDown) {
                // Nach unten scrollen: Header verstecken (nicht fixed)
                headerWrapper.classList.remove('header-visible');
            } else {
                // Nach oben scrollen: Header anzeigen (fixed von oben)
                headerWrapper.classList.add('header-visible');
            }
        } else {
            // Ganz oben: normaler Zustand
            headerWrapper.classList.remove('header-visible');
        }

        lastScrollY = currentScrollY;
        ticking = false;
    };

    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(updateHeader);
            ticking = true;
        }
    });
}
